'use client'

import Button from '@/components/ui/Button'
import FormInput from '@/components/ui/Forms/FormInput'
import { useSigninForm } from '@/hooks/forms/useSigninForm'
import { EyeOff, Mail } from 'lucide-react'
import Link from 'next/link'
import OTPForm from '../OTPForm'
import { FieldValues } from 'react-hook-form'
import AuthButtonsList from '../../../shared/AuthButtons/AuthButtonsList'

interface ISigninFormProps {
  isOTPScreen: boolean
  handleGoToOTP: () => void
  type?: 'page' | 'modal'
  openSignupModal?: () => void
}

const SigninForm = ({
  isOTPScreen,
  handleGoToOTP,
  type,
  openSignupModal
}: ISigninFormProps) => {
  const { register, onSubmit, handleSubmit, watch, errors, isLoading } =
    useSigninForm()

  const email = watch('email')

  if (isOTPScreen) return <OTPForm firstStepData={{ email }} type={'signup'} isInvitedUser={false} />

  return (
    <form
      onSubmit={handleSubmit((data: FieldValues) =>
        onSubmit(data, handleGoToOTP)
      )}
      className='mt-12'
    >
      <FormInput
        type='email'
        variant='primary'
        placeholder='Email'
        label='Email Address'
        id='signin-form-email'
        labelClassName='text-ui-black'
        icon={Mail}
        {...register('email')}
        error={errors.email?.message}
        disabled={isLoading}
      />
      <FormInput
        type='password'
        variant='primary'
        placeholder='Password'
        label='Enter password'
        wrapperClassName='mt-6'
        id='signin-form-password'
        labelClassName='text-ui-black'
        icon={EyeOff}
        {...register('password')}
        error={errors.password?.message}
        disabled={isLoading}
      />
      <div className='mt-2 w-full text-right'>
        <Link
          href='/agency/password-recovery'
          className='decoration-skip-ink-none text-sm font-semibold text-[#FE6434] underline decoration-solid underline-offset-auto'
          type='button'
        >
          Forgot Password?
        </Link>
      </div>
      <Button
        variant='orange'
        size='primary'
        className='mt-7 w-full'
        type='submit'
        disabled={isLoading}
      >
        Continue
      </Button>

      <AuthButtonsList />

      <div className='mt-4 text-left'>
        <span className='text-sm text-gray-500'>
          Don&apos;t have an account{' '}
        </span>
        {type === 'modal' ? (
          <Link
            href='#'
            onClick={openSignupModal}
            className='decoration-skip-ink-none text-sm font-medium text-[#FE6434] underline decoration-solid underline-offset-auto'
          >
            Sign Up
          </Link>
        ) : (
          <Link
            href='/agency/signup'
            className='decoration-skip-ink-none text-sm font-medium text-[#FE6434] underline decoration-solid underline-offset-auto'
          >
            Sign Up
          </Link>
        )}
      </div>
    </form>
  )
}

export default SigninForm
